// main
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import WebbDividerMedium from "../webx/webb-divider-md";

import { Button } from "antd";

export default function MainActionsModule () {
  
  const history = useHistory();
  
  return (
  <>
    <div className='p-3 back-color-lite rounded-wd'>
      <h3 className='m-0 text-color-tone'>Join the Creators Community</h3>
      <h2 className='m-0'>You Can Create !</h2>
      <h2 className='m-0 text-color-tone d-none'>and track your NFT Portfolio</h2>
      <p className='text-lead'>
        Behind every creation there is a creator. 
        The rest is evolution.
      </p>


      <WebbDividerMedium/>
      <Button 
        type="primary" 
        className='height-md back-color-main border-none rounded-wd px-3 me-1'
        onClick={() => history.push('/auth')}
      >Create Account</Button>

      <Button 
        type="" 
        className='height-md back-color-tint border-none rounded-wd px-3 me-1'
        onClick={() => history.push('/')}
      >iOS AppStore*</Button>
      
      <Button 
        type="" 
        className='height-md back-color-tint  border-none rounded-wd px-3'
        onClick={() => history.push('/')}
      >Google Play*</Button>

      <WebbDividerMedium/>
      <p className='m-0 text-small text-color-tone'>* Coming Soon</p>
    </div>
  </>
  )
}